/** Old public URLs remain valid after moving the site routes to English. */
export const legacyRoutes: Record<string, string> = {
  "/sistema-para-restaurantes": "/restaurant-management",
  "/cardapio-digital": "/digital-menu",
  "/comanda-digital": "/digital-orders",
  "/sistema-para-cozinha": "/kitchen-display",
  "/calculadora-cmv": "/food-cost-calculator",
  "/guias/como-calcular-cmv": "/guides/how-to-calculate-food-cost",
  "/sobre": "/about",
  "/contato": "/contact",
  "/privacidade": "/privacy",
  "/termos": "/terms"
};
